export const calculateDurationMilliseconds = (
  startTime: Date | null | undefined,
  endTime: Date = new Date(),
): number => {
  if (!startTime) {
    return 0;
  }
  return endTime.getTime() - startTime.getTime();
};

export const calculateDurationSeconds = (
  startTime: Date | null | undefined,
  options?: { endTime?: Date; round?: boolean },
): number => {
  const { endTime = new Date(), round = false } = options ?? {};
  const durationMs = calculateDurationMilliseconds(startTime, endTime);
  const durationSeconds = durationMs / 1000;
  return round ? Math.round(durationSeconds) : durationSeconds;
};

export const summarizeInteractedFields = (
  interactions: Set<string> | string[] | null | undefined,
): { interactedFields: string[]; fieldInteractionCount: number } => {
  if (!interactions) {
    return { interactedFields: [], fieldInteractionCount: 0 };
  }

  if (interactions instanceof Set) {
    const interactedFields = Array.from(interactions);
    return {
      interactedFields,
      fieldInteractionCount: interactedFields.length,
    };
  }

  const interactedFields = [...interactions];
  return {
    interactedFields,
    fieldInteractionCount: interactedFields.length,
  };
};

export const countFilledFields = (
  formState: Record<string, unknown> | null | undefined,
): number => {
  if (!formState) {
    return 0;
  }

  let count = 0;
  const countFields = (obj: Record<string, unknown> | unknown[]): void => {
    const values = Array.isArray(obj) ? obj : Object.values(obj);

    values.forEach((value) => {
      if (Array.isArray(value)) {
        countFields(value);
      } else if (typeof value === 'object' && value !== null) {
        countFields(value as Record<string, unknown>);
      } else if (value !== '' && value !== null && value !== undefined) {
        count++;
      }
    });
  };

  countFields(formState as Record<string, unknown>);
  return count;
};
